(function () {
  // Quick add on product cards: keep the hidden variant id + button price in
  // sync with the chosen pack/option. The form itself is a normal /cart/add
  // POST, so Assortion's cart drawer handles it like the PDP form.
  if (window.__ldCardQuickAdd) return;
  window.__ldCardQuickAdd = true;

  function setVariant(form, id, price) {
    var input = form.querySelector('[data-card-atc-id]');
    var priceEl = form.querySelector('[data-card-atc-price]');
    if (input) input.value = id;
    if (priceEl && price) priceEl.textContent = price;
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.product-card__pack');
    if (!pill || pill.disabled) return;
    e.preventDefault();
    var form = pill.closest('[data-card-atc]');
    if (!form) return;
    form.querySelectorAll('.product-card__pack').forEach(function (p) {
      var on = p === pill;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setVariant(form, pill.dataset.variantId, pill.dataset.price);
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-card-atc-select]');
    if (!select) return;
    var form = select.closest('[data-card-atc]');
    var opt = select.options[select.selectedIndex];
    if (form && opt) setVariant(form, opt.value, opt.dataset.price);
  });
})();
